module.exports = "pegasus/assets/theme2/medium/2.jpg";